import { InviteCode } from '@/models/invite-code';

import * as fb from '@/firebase';

import * as _ from 'lodash';

import { UserProfile } from '@/models/user-profile';

export class InviteCodeModelUtil {
  public static async findInviteCode(
    inviteCodeString: string
  ): Promise<InviteCode> {
    const inviteCodes = await fb.inviteCodesCollection
      .where('code', '==', inviteCodeString)
      .get();
    return inviteCodes.docs.map((inviteCode) => {
      return InviteCode.fromFirebaseDoc(inviteCode.id, inviteCode.data());
    })[0];
  }

  public static async isCodeFree(inviteCodeString: string): Promise<boolean> {
    return this.hasCodeBeenUsed(inviteCodeString).then((v) => !v);
  }

  public static async hasCodeBeenUsed(
    inviteCodeString: string
  ): Promise<boolean> {
    const inviteCode1 = await this.findInviteCode(inviteCodeString);
    if (inviteCode1) {
      return true;
    }

    const inviteCode2 = await fb.inviteCodesCollection
      .where('priorCodes', 'array-contains', inviteCodeString)
      .get();

    return !inviteCode2.empty;
  }

  public static generateCode(): string {
    const randomstring = require('randomstring');
    return randomstring.generate(10);
  }

  public static add(
    inviteCode: InviteCode,
    user: UserProfile
  ): Promise<firebase.firestore.DocumentReference> {
    inviteCode.creator = user.id;
    inviteCode.lastUpdatedBy = user.id;
    inviteCode.timeLastUpdated = new Date();
    return fb.inviteCodesCollection.add(inviteCode.toFirebaseDoc());
  }

  public static update(
    inviteCode: InviteCode,
    user: UserProfile
  ): Promise<void> {
    inviteCode.lastUpdatedBy = user.id;
    inviteCode.timeLastUpdated = new Date();
    inviteCode.priorCodes = _.uniq(
      inviteCode.priorCodes.concat([inviteCode.code])
    );
    return fb.inviteCodesCollection
      .doc(inviteCode.id)
      .update(inviteCode.toFirebaseDoc());
  }

  public static getAllCodes(): Promise<InviteCode[]> {
    return fb.inviteCodesCollection
      .orderBy('timeLastUpdated', 'desc')
      .get()
      .then((querySnapshot) =>
        querySnapshot.docs.map((d) => InviteCode.fromFirebaseDoc(d.id, d.data()))
      );
  }

  public static findUsersWhoUsedThisCode(
    inviteCode: InviteCode
  ): Promise<UserProfile[]> {
    return fb.usersCollection
      .where('inviteCodeId', '==', inviteCode.id)
      .get()
      .then((querySnapshot) => {
        console.log('users who used this', querySnapshot.docs);
        return querySnapshot.docs.map((d) =>
          UserProfile.fromFirebaseDoc(d.id, d.data())
        );
      });
  }

  public static async isValidForSingup(
    inviteCodeString: string
  ): Promise<boolean> {
    const inviteCode = await this.findInviteCode(inviteCodeString);
    return inviteCode.numUsed < inviteCode.maxUses;
  }

  public static async isValidForCreateProfile(
    inviteCodeString: string
  ): Promise<boolean> {
    const inviteCode = await this.findInviteCode(inviteCodeString);
    return inviteCode.numUsed < inviteCode.maxUses + 10;
  }

  public static isValid(inviteCode: InviteCode): boolean {
    return inviteCode.numUsed < inviteCode.maxUses;
  }
}
